var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8298 5.43766C10.6873 5.43766 10.5448 5.38516 10.4323 5.27266L8.90982 3.75016L7.38732 5.27266C7.16982 5.49016 6.80982 5.49016 6.59232 5.27266C6.37482 5.05516 6.37482 4.69516 6.59232 4.47766L8.51232 2.55766C8.72982 2.34016 9.08982 2.34016 9.30732 2.55766L11.2273 4.47766C11.4448 4.69516 11.4448 5.05516 11.2273 5.27266C11.1148 5.38516 10.9723 5.43766 10.8298 5.43766Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91016 11.1973C8.60266 11.1973 8.34766 10.9423 8.34766 10.6348V3.00732C8.34766 2.69982 8.60266 2.44482 8.91016 2.44482C9.21766 2.44482 9.47266 2.69982 9.47266 3.00732V10.6348C9.47266 10.9498 9.21766 11.1973 8.91016 11.1973Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5625C5.1375 15.5625 2.4375 12.8625 2.4375 9C2.4375 8.6925 2.6925 8.4375 3 8.4375C3.3075 8.4375 3.5625 8.6925 3.5625 9C3.5625 12.2025 5.7975 14.4375 9 14.4375C12.2025 14.4375 14.4375 12.2025 14.4375 9C14.4375 8.6925 14.6925 8.4375 15 8.4375C15.3075 8.4375 15.5625 8.6925 15.5625 9C15.5625 12.8625 12.8625 15.5625 9 15.5625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.dac01287ab7dbd95ae239dfcbee9201e.svg";
export { ForwardRef as ReactComponent };